<div class="pt-10"><app-event-header></app-event-header></div>
<div id="app-claim-ticket" class="app-claim-ticket">
    <div class="app-ticket" *ngIf="!showScheduleBtn">
        <div class="row justify-content-center">
            <div class=" col-10 col-md-6 col-lg-4" *ngIf="visibleView == 'contactDetail'">
                <div class="pt-50 pb-50 landing-page-auth">
                    <form [formGroup]="contactDetail" fxLayoutAlign="center center">
                        <div fxLayout="row wrap" fxFlex="100%" fxFlex.xs="100%" fxFlex.sm="100%"
                            fxLayoutAlign="center center" class="content-box">
                            <div class=" text-center" fxFlex="100%" fxFlex.xs="100%" fxLayoutAlign="center center">
                                <span class="box-title">Claim Ticket</span>
                            </div>
                            <div fxLayout="column" fxFlex="100%" class="claim-form-div mt-20 p-30 bg-secondary">
                                <div fxFlex="100%">
                                    <mat-form-field class="w-100">
                                        <mat-label>First Name</mat-label>
                                        <input matInput name="firstName" formControlName="firstName" required
                                            maxlength="35" allowValues isInputType="alphaNumeric"
                                            autocomplete="given-name">
                                        <mat-error *ngIf="contactDetail.get('firstName').hasError('required')">
                                            Please enter first Name
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <div fxFlex="100%">
                                    <mat-form-field class="w-100">
                                        <mat-label>Last Name</mat-label>
                                        <input matInput name="username" formControlName="lastName" required
                                            maxlength="35" allowValues isInputType="alphaNumeric"
                                            autocomplete="family-name">
                                        <mat-error *ngIf="contactDetail.get('lastName').hasError('required')">
                                            Please enter last name
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <div fxFlex="100%">
                                    <mat-form-field class="w-100">
                                        <mat-label>Email</mat-label>
                                        <input matInput name="email" formControlName="email" required maxlength="255"
                                            autocomplete="email">
                                        <mat-error *ngIf="contactDetail.get('email').hasError('required')">
                                            Please enter email
                                        </mat-error>
                                        <mat-error *ngIf="contactDetail.get('email').hasError('email') || contactDetail.get('email').hasError('pattern')">
                                            Please enter valid email
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <button mat-flat-button class="w-30 flat-primary-button mt-15 secondary-bg-button"
                                    (click)="verifyEmail()">Submit
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>

        <!-- Questions Section Start -->
        <ng-container *ngIf="visibleView == 'questionList'">
            <h3 class="heading pt-20">Questionnaire</h3>
            <div class="questions-div pb-25 bg-secondary">
                <div class="mb-100">
                    <form name="form" #f="ngForm" novalidate>
                        <ng-container *ngFor="let user of questionsListNew; let k=index">
                            <h3 class="questions-heading pl-15 pt-5 w-100">
                                {{user.type == 'general' ? 'General' :user.type}}</h3>
                            <!-- <h3 class="questions-heading pl-15 pt-5 w-100" *ngIf="user.type != 'general'">
                                {{user.type}}</h3> -->
                            <div class="q-container ticket_questions mt-10"
                                *ngFor="let qtn of user.userQuestions; let i=index">
                                <!-- <h3 class="questions-heading pl-15 pt-5 w-100" *ngIf="qtn.question_type == 'general'">
                                    General
                                    </h3>
                                <h3 class="questions-heading pl-15 pt-5 w-100" *ngIf="qtn.ticket_name">
                                    {{qtn.ticket_name}}
                                </h3> -->
                                <!-- <div></div> -->
                                <label><span class="q-number">Q{{i+1}}:</span> {{qtn.question}} <span
                                        *ngIf="qtn.is_mandatory" class="mandtory-icon">*</span></label>

                                <mat-form-field class="ml-25" *ngIf="qtn.option_type === 'textbox'">
                                    <input [(ngModel)]="qtn.value" name="textbox-{{j}}{{i}}" #value="ngModel"
                                        [required]="qtn.is_mandatory == 1 ? true : false" matInput>
                                </mat-form-field>
                                <mat-form-field class="ml-25" *ngIf="qtn.option_type === 'textarea'">
                                    <textarea [(ngModel)]="qtn.value" name="textArea-{{j}}{{i}}" #value="ngModel" matInput
                                        [required]="qtn.is_mandatory == 1 ? true : false"></textarea>
                                </mat-form-field>
                                <mat-form-field class="ml-25" *ngIf="qtn.option_type === 'select'">
                                    <mat-select [(ngModel)]="qtn.value" name="select-{{j}}{{i}}" #value="ngModel"
                                        [required]="qtn.is_mandatory == 1 ? true : false">
                                        <mat-option [value]="opt.option" *ngFor="let opt of qtn.options">{{opt.option}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>

                                <section class="q-section ml-25 radio-checkbox" *ngIf="qtn.option_type === 'checkbox'">
                                    <ng-container *ngFor="let opt of qtn.options;let z = index;">
                                        <mat-checkbox [(ngModel)]="opt.value" name="checkbox-{{j}}{{i}}{{z}}"
                                            #value="ngModel" class="fw-300 mr-10">
                                            {{opt.option}}
                                        </mat-checkbox>
                                    </ng-container>
                                </section>
                                <section class="q-section ml-25" *ngIf="qtn.option_type === 'radio'">
                                    <mat-radio-group [(ngModel)]="qtn.value" name="radio-{{j}}{{i}}" #value="ngModel"
                                        [required]="qtn.is_mandatory == 1 ? true : false">
                                        <mat-radio-button [value]="opt.option" class="pr-2"
                                            *ngFor="let opt of qtn.options">
                                            {{opt.option}}</mat-radio-button>
                                    </mat-radio-group>
                                </section>
                            </div>
                        </ng-container>
                        <div class="m-20">
                            <button mat-raised-button class="flat-primary-button secondary-bg-button" (click)="saveQuestions(f.form.valid)">
                                Next
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </ng-container>
    </div>
    <ng-container *ngIf="showScheduleBtn">
        <div class="text-center">
            <ng-container *ngIf="device != 'android' && device != 'ios'">
                <button mat-flat-button class="flat-primary-button mt-15 primary-bg-button" (click)="redirectTo()">Go To Schedule
                </button>
            </ng-container>
            <ng-container *ngIf="device == 'android' || device == 'ios'">
                <div class="mt-30">
                    <ng-container *ngIf="device == 'android'">
                        <h5 class="text-center pt-40 fs-16 plr-10">
                            Please download {{clientDetails.name}}'s app from Play Store to watch the stream on mobile.</h5>
                            <div class="text-center mt-20">
                                <a href="https://play.google.com/store/apps/details?id=com.arevea.tv" target="_blank"><img
                                        [src]="assets_url + 'website/homepage/googleplay.png'" class="store-img"></a>
                            </div>
                        <h5 class="text-center fs-16 mt-20 plr-10">Already have app? Click below link to open app.</h5>
                    </ng-container>
                    <ng-container *ngIf="device == 'ios'">
                        <h5 class="text-center pt-40 fs-16 plr-10">Please download {{clientDetails.name}}'s app from App Store to watch the stream on mobile.</h5>
                        <div class="text-center mt-20">
                            <a href="https://apps.apple.com/in/app/arevea/id1535047464" target="_blank"><img [src]="assets_url + 'website/homepage/appstore.png'"
                                    class="store-img"></a>
                        </div>
                    </ng-container>
                    <div class="mt-30">
                    <a *ngIf="device == 'android'" class="flat-primary-button schedule-btn" target="_other" rel="nofollow" [href]="scheduleUrl">Go
                        To
                        Schedule</a></div>
                </div>
            </ng-container>
        </div>
    </ng-container>
</div>